angular.module("KhBase")
.factory("FieldNamesFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/fms/farmfield/', {as_dict: 'yes'});
}]);